// Styles
import '@styles/app.css';

// Commons
import header from '@commons/header';
import main from '@commons/main';

// Entry point logic
export default async function init() {
  header();
  main();
}

init();
